import tokens from './tokens'
import { SerializedFarmConfig } from './types'

const priceHelperLps: SerializedFarmConfig[] = [
  /**
   * These LPs are just used to help with price calculation for MasterChef LPs (farms.ts).
   * This list is added to the MasterChefLps and passed to fetchFarm. The calls to get contract information about the token/quoteToken in the LP are still made.
   * The absence of a PID means the masterchef contract calls are skipped for this farm.
   * Prices are then fetched for all farms (masterchef + priceHelperLps).
   * Before storing to redux, farms without a PID are filtered out.
   */
  {
    pid: null,
    //lpSymbol: 'QSD-BNB LP',
    lpSymbol: 'DtUsd-DtBCH LP',
    lpAddresses: {
      //10001: '0x9f6CFAA7604752169BaF059E88B49bCbc17799A1', // pair as provided by teh factroy // todo xxxxx set price helper pool
      //10001: '0xA61679365e65d747002756233D8E6DA57a0A6469',
      10001: '0xDEADBEEFDEADBEEFDEADBEEFDEADBEEFDEADBEEF',
      10000: '0x252F7754CB96971898F49C318126C4c024660894',

      // original pool:
      // 56: '0x7b3ae32eE8C532016f3E31C8941D937c59e055B9',
      // AdminUpgradeabilityProxy QSD: 0x07AaA29E63FFEB2EBf59B33eE61437E1a91A3bb2 https://www.coingecko.com/en/coins/qian-second-generation-dollar
      // WBNB:  0xbb4CdB9CBd36B01bD1cBaEBF2De08d9173bc095c
    },
    //token: tokens.qsd,
    //quoteToken: tokens.wbnb,
    //token: tokens.tt8,
    token: tokens.dtusd,
    quoteToken: tokens.dtbch,
  },
]

export default priceHelperLps
